import $ from 'jquery';
import _ from 'lodash';
import QualityIndicators from '../helpers/quality-indicators';
import TemplateCommon from '../helpers/template-common';
import moment from "moment";
import LoginService from '../../services/login.service';
import UtilsService from "../../services/utils.service";

// TODO:  Move inline styles into CSS classes

    var getDivWithContentAndAttrs = TemplateCommon.getDivWithContentAndAttrs;

    var DATA_TYPE = {
        NUMERIC: 'numeric',
        STRING: 'string',
        DATETIME: 'datetime'
    };

    var HARDWARE_STATUS_CODE_MAP = {
        NONE_FOUND: {
            DISPLAY: -100,
            SOURCE: -200
        },
        CONNECTION_INFO_MISSING: {
            DISPLAY: -102,
            SOURCE: -202
        },
        CONNECTED: {
            DISPLAY: 101,
            SOURCE: 201
        },
        NOT_CONNECTED: {
            DISPLAY: -101,
            SOURCE: -201
        }
    };

    var STATUS = {
        CONNECTED: 'Connected',
        NOT_CONNECTED: 'Not Connected',
        SIP_TOLL_ATTACK: 'SIP Toll Attack'
    };

    function GridFormatterCommon() {
        var self = this;

        self.GREEN = "var(--good-color)"; // "#1abc9c";
        self.RED = "var(--bad-color)"; //"#e74c3c";
        self.YELLOW = "#db8b0b"; //"#f1c40f";
        self.BLUE = "#0073b7"; //"#25A0DB";
    }

    GridFormatterCommon.prototype = {
        composeEmpty: function(headers, rowProperties, widths) {
            return {
                maxCount: 0,
                rows: [],
                headers: headers || [],
                rowProperties: rowProperties || [],
                widths: widths || []
            };
        },
        convertStatusToNumber: function(status) {
            if (status) {
                switch (status.toUpperCase()) {
                    case "INCALL":
                        return 0;
                    case "NOTAVAILABLE":
                        return 1;
                    case "AVAILABLE":
                        return 2;
                    case "NONE":
                        return 3;
                    default:
                        return -1;
                }
            } else {
                return -1;
            }
        },
        formatJitterValue: function(val, type, channel) {
            var self = this;

            if (!val) {
                return '-'; // why??
            }

            var className = UtilsService.formatThreshold('jitter', channel, ['valGreen', 'valYellow', 'valRed'],'valGreen', val);
            if (type !== 'percentage') {
                val = val + " ms"
            }
            return getDivWithContentAndAttrs(val, { 'class': className }, true);
        },
        formatPacketLossValue: function(val, type, channel) {
            var self = this;

            if (!val) {
                return '-'; // why?
            }

            let rawValue = (type === 'percentage') ? val.slice(0, -1) : val;
            var className = UtilsService.formatThreshold('packetLoss', channel,['valGreen', 'valYellow', 'valRed'], '', rawValue);
            var formattedValue = parseFloat(parseFloat(rawValue).toFixed(2));
            formattedValue = (type === 'percentage') ? formattedValue + '%' : formattedValue;

            return getDivWithContentAndAttrs(formattedValue, { 'class': className }, true);
        },
        formatLatencyValue: function(val, type, channel) {
          var self = this;

          if (!val) {
            return '-'; // why?
          }

          var className = UtilsService.formatThreshold('latency', channel, ['valGreen', 'valYellow', 'valRed'],'valGreen', val);
            if (type !== 'percentage') {
                val = val + " ms"
            }
          return getDivWithContentAndAttrs(val, { 'class': className }, true);
        },
        formatStatusDiv: function(val) {
            var className;

            if (val === STATUS.CONNECTED) {
                className = "callStatusGreen1";
            }
            else if (val === STATUS.NOT_CONNECTED) {
                className = "callStatusRed1";
            }
            else if (val === STATUS.SIP_TOLL_ATTACK) {
                className = "callStatusRed1";
            }
            else {
                className = "callStatusGreen1";
            }
            return TemplateCommon.getSpanWithContentAndAttrs(val, { 'class': className });
        },
        getColWidths: function(cols, widthRatioProp) {
            widthRatioProp = widthRatioProp || 'widthRatio';

            return _.map(cols, function (col) {
                var widthRatioValue;

                if (!col[widthRatioProp]) {
                    console.warn('No width radio provided for col ' + col.name + '. Default width is set to 10%');
                    widthRatioValue = '10%';
                }
                else {
                    widthRatioValue = '' + Math.round(col[widthRatioProp] * 100 / cols.length) + '%';
                }
                return widthRatioValue;
            });
        },
        /**
         * GetDurationString
         *
         * @param diff
         * @returns {string}
         * @constructor
         */
        GetDurationString: function(diff) {
            var result = "";

            if (diff) {
                var msec = diff;
                var hh = Math.floor(msec / 1000 / 60 / 60);
                msec -= hh * 1000 * 60 * 60;
                var mm = Math.floor(msec / 1000 / 60);
                msec -= mm * 1000 * 60;
                var ss = Math.floor(msec / 1000);

                var hours = hh;
                var minutes = ('0' + mm).slice(-2);
                var seconds = ('0' + ss).slice(-2);

                result = hours + ":" + minutes + ":" + seconds /*+ "." + msec*/;
            }
            return result;
        },
        getTimeString: function(time) {
            if (time) {
                let datetime = moment.utc(time, 'YYYY-MM-DDTHH:mm:ss');
                if (LoginService.userObject && LoginService.userObject.farmG2) {
                    // convert time from UTC to org time and show time zone
                    datetime = moment(datetime).tz(LoginService.userObject.timezoneId);
                    return datetime.format('D MMM YYYY - HH:mm:ss z');

                }
                return datetime.format('D MMM YYYY - HH:mm:ss');
            }
            return time;
        },
        getHwStatuses: function(AVS) {
            if (_.isEmpty(AVS)) {
                return null;
            }
            var displaymessages = getHWStatusMessages(AVS[0].Displays, true /*isDisplay*/);
            var sourcemessages = getHWStatusMessages(AVS[0].Sources, false /*isDisplay*/);

            return { displaymessages: displaymessages, sourcemessages: sourcemessages };
        },

        getHwStatusMarkup: function(AVS) {
            var self = this;
            var statuses = self.getHwStatuses(AVS);
            return (!statuses) ? '' : getAVSMarkup(statuses.displaymessages, statuses.sourcemessages);
        },

        getHwStatusValue: function(AVS) {
            var self = this;
            var statuses = self.getHwStatuses(AVS);

            if (!statuses) {
                return 0;
            }

            var displaymessages = statuses.displaymessages;
            var sourcemessages = statuses.sourcemessages;
            var result = 0;

            if (sourcemessages[0].code === HARDWARE_STATUS_CODE_MAP.NONE_FOUND.SOURCE) {
                result = 20;
            }
            else {
                var hasConnectedCamera = _.some(sourcemessages, function(m) {
                    return m.code === HARDWARE_STATUS_CODE_MAP.CONNECTED.SOURCE &&
                        _.toLower(_.get(m, 'source.SignalType[0].text', '')) === 'camera';
                });
                // These are arbitrary HW Status weights (10, 20) so that when sorting connected devices appear higher (when sorting ASC)
                // TODO: Need to revisit this logic as it is not very intuitive.
                result = hasConnectedCamera ? 20 : 10;
            }

            if (displaymessages[0].code === HARDWARE_STATUS_CODE_MAP.NONE_FOUND.DISPLAY) {
                result += 2;
            }
            else {
                var hasConnectedDisplay = _.some(displaymessages, function(m) {
                    return m.code === HARDWARE_STATUS_CODE_MAP.CONNECTED.DISPLAY;
                });
                // Adding arbitrary weight so that connected displays also are considered when sorting by HW status
                // TODO: Need to revisit logic.
                result += hasConnectedDisplay ? 2 : 1;
            }
            return result;
        },

        getLink: function(host) {
            return TemplateCommon.getHtmlTagWithContentAndAttrs("a", host, { href: host, title: host });
        },

        getLinkImageWithName: function(name, host, linkname) {
            var spanAttrsObj = _.extend({
                title: name
            }, (!linkname) ? {} : { 'class': 'qualitylink' });

            return '<a href="https://' + host + '" target="_blank" rel="noopener noreferrer" title="' + host + '">' +
                TemplateCommon.getSpanWithContentAndAttrs(null, { 'class': 'flaticon-login17 icon100perc lblEnter' }) +
                '</a>&nbsp;' + TemplateCommon.getSpanWithContentAndAttrs(name, spanAttrsObj);
        },

        getLinkWithHost: function(host) {
            return host ? '<a style="cursor: pointer" href="https://' + host + '" target="_blank" rel="noopener noreferrer" title="' + host + '">' + host + '</a>&nbsp;' : '';
        },

        getProgressBar: function(maxValue, barValue, maxEmptyMessage, status) {
            var result;

            if (_.isNil(barValue) || isNaN(barValue) || isNaN(maxValue) || (status && (status.toUpperCase() !== "OK"))) {
                result = "";
            }
            else if (_.isNil(maxValue) || (_.toNumber(maxValue) === 0)) {
                var spanAttrsObj = {
                    style: 'color:red;',
                    title: ''
                };
                result = maxEmptyMessage ? TemplateCommon.getSpanWithContentAndAttrs(maxEmptyMessage, spanAttrsObj) : "";
            }
            else {
                var percent = Math.round(barValue * 100 / maxValue);
                var bg;
                if (percent >= 80) {
                    bg = "red"; // self.RED;

                } else if (percent >= 60) {
                    bg = "yellow"; // self.YELLOW;

                } else {
                    bg = "green"; // self.GREEN;
                }

                var barPercent = (percent > 100) ? 100 : percent;
                var percentLabel = percent + "%";
                var outerDivAttrsObj = {
                    style: 'width:100%',
                    title: percentLabel
                };

                if ($(window).width() < 991) {
                    var innerDivAttrsObj = {
                        style: 'color:"' + bg + '";font-weight:bold;',
                        title: percentLabel
                    };
                    result = getDivWithContentAndAttrs(getDivWithContentAndAttrs(percentLabel, innerDivAttrsObj, true), outerDivAttrsObj);
                }
                else {
                    var firstInnerDivContent = barValue + "/" + maxValue;
                    var firstInnerDivAttrsObj = {
                        style: 'display:inline-block;width:20%;',
                        title: firstInnerDivContent
                    };

                    var secondInnerDivContent = getDivWithContentAndAttrs(null, {
                        'class': 'progress-bar progress-bar-' + bg,
                        style: 'width:' + barPercent + '%;'
                    }, true);
                    var secondInnerDivAttrsObj = {
                        'class': 'progress progress-xs',
                        style: 'margin-left:auto;margin-right:auto;display:inline-block;width:50%;height:12px;',
                        title: percentLabel
                    };

                    var thirdInnerDivContent = percentLabel;
                    var thirdInnerDivAttrsObj = {
                        style: 'display:inline-block;width:20%;margin-left:10px;',
                        title: percentLabel
                    };

                    result = getDivWithContentAndAttrs(
                        getDivWithContentAndAttrs(firstInnerDivContent, firstInnerDivAttrsObj, true) +
                        getDivWithContentAndAttrs(secondInnerDivContent, secondInnerDivAttrsObj) +
                        getDivWithContentAndAttrs(thirdInnerDivContent, thirdInnerDivAttrsObj, true),
                        outerDivAttrsObj);
                }
            }
            return result;
        },

        getProgressBarACANO: function(maxValue, barValue, status) {
            if (!_.isFinite(barValue) || !_.isFinite(maxValue) || maxValue === 0 || (!_.isEmpty(status) && _.toUpper(status) !== 'OK')) {
                return '';
            }

            var percent = Math.round(barValue * 100 / maxValue);
            var bg = "green"; // self.GREEN;
            if (percent >= 60) {
                bg = "yellow"; // self.YELLOW;
            }
            if (percent >= 80) {
                bg = "red"; // self.RED;
            }

            var barpercent = (percent > 100) ? 100 : percent;

            if ($(window).width() < 991) {
                return percent + "%";
            }

            return "<div style='width:100%' title='" + percent + "%'>" +
                        "<div class='progress progress-xs' style='margin-left: auto; margin-right: auto; display: inline-block; width: 50%; height:12px' title='" + percent + "%'>" +
                            "<div class='progress-bar progress-bar-" + bg + "' style='width: " + barpercent + "%'></div>" +
                        "</div>" +
                        "<div style='display:inline-block;width:20%;margin-left:10px;' title='" + percent +"%'>" + percent + "%</div>" +
                    "</div>";
        },

        getProgressBarCTPS: function(maxValue, barValue) {
            if (!_.isFinite(barValue) || !_.isFinite(maxValue) || maxValue === 0) {
                return '';
            }

            var percent = Math.round(barValue * 100 / maxValue);
            var bg = "green"; // self.GREEN;
            if (percent >= 60) {
                bg = "yellow"; // self.YELLOW;
            }
            if (percent >= 80) {
                bg = "red"; // self.RED;
            }

            var barpercent = (percent > 100) ? 100 : percent;

            if ($(window).width() < 991) {
                return parseFloat(barValue.toString()).toFixed(2) + "/" +
                    Math.round(maxValue) + " = " +
                    parseFloat(percent.toString()).toFixed(2) + "%";
            }
            var formattedBarValue = parseFloat(barValue.toString()).toFixed(2);
            var formattedPercent = parseFloat(percent.toString()).toFixed(2);
            var roundedMaxValue = Math.round(maxValue);
            return "<div style='width:100%' title='" + parseFloat(percent.toString()).toFixed(2) + "%'>" +
                        "<div style='display:inline-block;width:20%' title='" + formattedBarValue + "/" + roundedMaxValue + "'>" + formattedBarValue + "/" + roundedMaxValue + "</div>" +
                        "<div class='progress progress-xs' style='margin-left: auto; margin-right: auto; display: inline-block; width: 50%; height:12px' title='" + formattedPercent + "%'>" +
                            "<div class='progress-bar progress-bar-" + bg + "' style='width: " + barpercent + "%'>" +
                        "</div>" +
                    "</div>" +
                    "<div style='display:inline-block;width:20%;margin-left:10px;'>" + formattedPercent + "%</div>";
        },

        getQualityClass: function(val) {
            var className;

            switch (val) {
                case 'Bad':
                case 'Fair':
                case 'Good':
                    className = 'quality' + val;
                    break;

                default:
                    className = 'qualityUnknown';
                    break;
            }
            return TemplateCommon.getSpanWithContentAndAttrs(val, { 'class': className });
        },

        getQualityMarkup: function(value) {
            var className = "";
            var text = "";

            if (QualityIndicators.isBad(value)) {
                className = "valRedFont";
                text = "Bad";
            }
            else if (QualityIndicators.isFair(value)) {
                className = "valYellowFont";
                text = "Fair";

            }
            else if (QualityIndicators.isGood(value)) {
                className = "valGreenFont";
                text = "Good";
            }
            var spanAttrsObj = {
                'class': className,
                style: 'display:inline-block;width:30px;',
                title: 'Quality score is based on values of jitter and packet loss'
            };
            return TemplateCommon.getSpanWithContentAndAttrs(text, spanAttrsObj);
        },

        getQualityMetricMarkupWithoutUnits: function(quality, value) {
            var className = '';
            value = value || ''; // default to empty string

            if (QualityIndicators.isBad(quality)) {
                className = 'valRed';
            }
            else if (QualityIndicators.isFair(quality)) {
                className = 'valYellow';
            }
            return getDivWithContentAndAttrs(value, {
                'class': className,
                title: value
            }, true);
        },

        getSolarWindsAndDetailLink: function(name, link, id) {
            var app = _.includes(window.location.href, '#monitoring') ? 'monitoring' : 'historical2';
            if (!link) {
                return "<a href='#" + app + "/endpoint/" + id + "/tabid/0' title='" + name + "'>" + name + "</a>";
            }
            return '<a href="' + link + '" target="_blank" rel="noopener noreferrer" title="' + name + '">' +
                '<img src="dist/images/SolarWinds.png" width="20"  alt="link to solarwinds">' +
                '</a>&nbsp;<a href="#'+app+'/endpoint/' + id + '/tabid/0" title="' + name + '">' + name + '</a>';
        },

        getSolarWindsLink: function(name, link, hasDetail) {
            var result;
            var title = (name || link);
            var spanAttrsObj = _.extend(
                {},
                (hasDetail) ? { 'class': 'qualitylink' } : {},
                { title: title }
            );
            var spanEl = TemplateCommon.getSpanWithContentAndAttrs(name, spanAttrsObj);

            if (!link) {
                result = spanEl;
            }
            else {
                result =
                    '<a style="cursor:pointer;" href="' + link + '\" target="_blank" rel="noopener noreferrer" title="' + title + '">' +
                        '<img src="dist/images/SolarWinds.png" width="20"  alt="link to solarwinds">' +
                    '</a>&nbsp;' + spanEl;
            }
            return result;
        },

        getStatusMarkup: function(status) {
            var className;

            if (status.toUpperCase() === "OK") {
                className = 'flaticon-circle111 iconpanel fonticonGreen';
            }
            else if (status.toUpperCase() === "UNREACHABLE") {
                className = 'flaticon-circle111 iconpanel fonticonRed';
            }
            else {
                className = 'flaticon-circle111 iconpanel fonticonGray';
            }
            return getDivWithContentAndAttrs(TemplateCommon.getSpanWithContentAndAttrs(null, {
                'class': className,
                title: status
            }), {
                style: 'width:100%;',
                title: status
            });
        },

        getStatusMarkupForEndpoint: function(status) {
            var className;
            var baseSpanAttrsObj;
            var extendedSpanAttrsObj;
            var statusLabel;

            switch (status) {
                case 0:
                case '0':
                    className = 'iconpanel fas fa-circle-phone semantic-incall';
                    statusLabel = 'In Call';
                    break;

                case 2:
                case '2':
                    className = 'iconpanel fas fa-check-circle semantic-good';
                    statusLabel = 'Available';
                    break;

                case 3:
                case '3':
                    className = 'iconpanel fas fa-question-circle semantic-neutral';
                    statusLabel = 'None';
                    break;

                default:
                    className = 'iconpanel fas fa-exclamation-circle semantic-bad';
                    statusLabel = 'Not Available';
            }

            baseSpanAttrsObj = { title: statusLabel };
            extendedSpanAttrsObj = _.extend({}, baseSpanAttrsObj, { 'class': className });

            return getDivWithContentAndAttrs(
                TemplateCommon.getSpanWithContentAndAttrs(null, extendedSpanAttrsObj) + '&nbsp;&nbsp;' +
                TemplateCommon.getSpanWithContentAndAttrs(statusLabel, baseSpanAttrsObj)
            );
        },

        getVMRLink: function(displayText) {
            return TemplateCommon.getSpanWithContentAndAttrs(displayText);
        },

        isFloat: function(n) {
            return n === +n && n !== (n | 0);
        },

        isInteger: function(n) {
            return n === +n && n === (n | 0);
        },

        MatchItemToSearch: function(item, searchfilter, keys, transformer) {
            for (var key in item) {
                if ($.inArray(key, keys) > -1) {
                    var lhs = transformer(key, item[key]);
                    var rhs = searchfilter.toUpperCase().split(" ");

                    //remove null element
                    rhs = $.grep(rhs, function(n) {
                        return (n !== "" && n !== null);
                    });

                    for (var i = 0; i < rhs.length; i++) {
                        if (lhs.indexOf(rhs[i]) > -1) {
                            return true; // found
                        }
                    }
                }
            }
            return false; // not found
        },

        matchStatusFilter: function(itemStatus, statusFilter) {
            var status = itemStatus.toUpperCase();

            if (status === "INCALL") {
                status = "IN CALL";
            }
            if (status === "NOTAVAILABLE") {
                status = "NOT AVAILABLE";
            }
            if (status === "NONE") {
                status = "NOT CONFIGURED";
            }
            return _.includes(statusFilter, status);
        },

        pageList: function(list, options) {
            var result;

            if (!options || !options.pageNum) {
                result = list;
            }
            else {
                var pageNum = options.pageNum;
                var pageSize = options.pageSize ? options.pageSize : 10;

                if ((pageNum <= 0) || (list.length <= pageSize)) {
                    result = list;
                }
                else {
                    result = list.slice((pageNum - 1) * pageSize, pageNum * pageSize);
                }
            }
            return result;
        },

        presentationText: function(txt) {
            var result;

            switch (txt) {
                case 'true':
                    result = 'On';
                    break;

                case 'false':
                    result = 'Off';
                    break;

                default:
                    result = "";
            }
            return result;
        },

        setClass: function(value, className) {
            return TemplateCommon.getSpanWithContentAndAttrs(value, { 'class': className });
        },

        sortList: function(list, sortableProperties, options, numericKeys, dateTimeKeys) {
            list = _.clone(list); // making sortList a pure function. There are no side-effects, all order changes are done in a new array.
            var result;
            var sortIndex = _.get(options, 'sortIndex', null);


            if (_.isEmpty(list) || _.isEmpty(sortableProperties) ||
                sortIndex === null || sortIndex >= sortableProperties.length) {
                result = list;
            }
            else {
                var sortAsc = _.get(options, 'sortAsc', true); // default to ASC
                var key = sortableProperties[sortIndex];
                var type = getKeyDataType(key, numericKeys, dateTimeKeys);

                result = list.sort(function (a, b) {
                    return compare(a[key], b[key], sortAsc, type);
                });
            }
            return result;
        },

        transformValueForSearchCommon: function(key, lhs) {
            var self = this;

            if ($.type(lhs) === 'boolean') {
                if (!lhs) {
                    lhs = "false";
                }
            }

            lhs = lhs ? lhs.toString().toUpperCase() : "";

            if (key === "status") {
                if (lhs === "NONE") {
                    lhs = "NOT CONFIGURED";
                }
            }
            else if (key === "duration") {
                lhs = self.GetDurationString(lhs);
            }
            else if (key === "qualityIndicator") {
                if (lhs === "1") {
                    lhs = "GOOD";
                }
                else if (lhs === "2") {
                    lhs = "FAIR";
                }
                else if (lhs === "3") {
                    lhs = "BAD";
                }else {
                    lhs = "#";
                }
            }
            return lhs;
        },

        transformValueForVMRSearch: function(key, lhs) {
            var self = this;

            if (key === "presentation") {
                lhs = self.presentationText(lhs).toUpperCase();
            }
            else {
                lhs = self.transformValueForSearchCommon(key, lhs);
            }
            return lhs;
        }
    };

    function getKeyDataType(key, numericKeys, dateTimeKeys) {
        var type = DATA_TYPE.STRING; // default value

        if (_.includes(numericKeys, key)) {
            type = DATA_TYPE.NUMERIC;
        }
        else if (_.includes(dateTimeKeys, key)) {
            type = DATA_TYPE.DATETIME;
        }
        return type;
    }

    function compare(lhs, rhs, asc, dataType) {
        var result;

        switch (dataType) {
            case DATA_TYPE.NUMERIC:
                lhs = parseFloat(lhs);
                rhs = parseFloat(rhs);

                if (isNaN(lhs)) {
                    lhs = -1;
                }
                if (isNaN(rhs)) {
                    rhs = -1;
                }
                break;
            case DATA_TYPE.DATETIME:
                lhs = new Date(lhs).getTime();
                rhs = new Date(rhs).getTime();
                break;
            default:
                lhs = _.toLower(_.toString(lhs));
                rhs = _.toLower(_.toString(rhs));
        }
        if (asc) {
            result = ((lhs < rhs) ? -1 : ((lhs > rhs) ? 1 : 0));
        }
        else {
            result = ((lhs > rhs) ? -1 : ((lhs < rhs) ? 1 : 0));
        }
        return result;
    }

    function getAVSMarkup(displaymessages, sourcemessages) {
        var result = "";

        if (sourcemessages[0].code === HARDWARE_STATUS_CODE_MAP.NONE_FOUND.SOURCE) {
            result += "<i title='No sources found' class='fa fa-camera' style='color: grey'></i>";
        }
        else {
            var hasConnectedCamera = _.some(sourcemessages, function(m) {
                return m.code === HARDWARE_STATUS_CODE_MAP.CONNECTED.SOURCE &&
                    _.toLower(_.get(m, 'source.SignalType[0].text', '')) === 'camera';
            });

            if (hasConnectedCamera) {
                result += "<i title='Camera is connected' class='fa fa-camera' style='color: green'></i>";
            }
            else {
                result += "<i title='No connected cameras found' class='fa fa-camera' style='color: red'></i>";
            }
        }
        result += "&nbsp;";

        if (displaymessages[0].code === HARDWARE_STATUS_CODE_MAP.NONE_FOUND.DISPLAY) {
            result += "<i title='No displays found' class='fa fa-desktop' style='color: grey'></i>";
        }
        else {
            var connectedDisplays = _.reduce(displaymessages, function(counter, message) {
                return message.code === HARDWARE_STATUS_CODE_MAP.CONNECTED.DISPLAY ? ++counter /*count connected displays*/ : counter;
            }, 0);

            if (connectedDisplays === 0) {
                result += "<i title='No connected displays found' class='fa fa-desktop' style='color: red'></i>";
            }
            else {
                result += "<i title='" + connectedDisplays + " Displays are connected' class='fa fa-desktop' style='color: green'></i>";
            }
        }
        return result;
    }

    function getHWStatusMessages(sources, isDisplay) {
        var messages;
        var type = isDisplay ? 'DISPLAY' : 'SOURCE';
        var sourceProp = _.toLower(type);

        if (_.isEmpty(sources)) {
            messages = [ _.set({ code: HARDWARE_STATUS_CODE_MAP.NONE_FOUND[type] }, sourceProp, null) ];
        }
        else {
            var code;
            messages = _.map(sources, function(source) {
                if (_.isEmpty(_.get(source, 'Connected'))) {
                    code = HARDWARE_STATUS_CODE_MAP.CONNECTION_INFO_MISSING[type];
                }
                else {
                    code = _.get(source.Connected, [0, 'text']) === 'True' ?
                        HARDWARE_STATUS_CODE_MAP.CONNECTED[type] :
                        HARDWARE_STATUS_CODE_MAP.NOT_CONNECTED[type];
                }
                return _.set({ code: code }, sourceProp, source);
            });
        }
        return messages;
    }

    export default GridFormatterCommon;
